mainApp.directive('addSite', function(LocationService) {
    return {
        templateUrl: '/public/directives/addSite.html',
        scope: false,
        controller: ["$scope","IconsService",function($scope,IconsService) {
            if (!$scope.newSite) {
                $scope.newSite = {};
            }

            // stating which WAN we will want
            $scope.enableSecondaryWAN = {value :false};

            $scope.icons = IconsService.getIcons();

            /**
             * function when closing the site we re-initiate the secondary WAN
             * property and closing the dialog
             */
            $scope.closeAddSite = function () {
                $scope.enableSecondaryWAN = {value :false};
                $scope.$root.closePopup('addSiteDlg');
            };

            $scope.licenseChange = function() {
                if ($scope.newSite.siteUsage) {
                    if (!$scope.newSite.wan1DownstreamBandwidth) {
                        $scope.newSite.wan1DownstreamBandwidth = $scope.newSite.siteUsage.maxBandwidth;
                    }
                    if (!$scope.newSite.wan1UpstreamBandwidth) {
                        $scope.newSite.wan1UpstreamBandwidth = $scope.newSite.siteUsage.maxBandwidth;
                    }
                    if($scope.enableSecondaryWAN && $scope.enableSecondaryWAN.value == true){
                        if (!$scope.newSite.wan2DownstreamBandwidth) {
                            $scope.newSite.wan2DownstreamBandwidth = $scope.newSite.siteUsage.maxBandwidth;
                        }
                        if (!$scope.newSite.wan2UpstreamBandwidth) {
                            $scope.newSite.wan2UpstreamBandwidth = $scope.newSite.siteUsage.maxBandwidth;
                        }
                    }
                }
            };

            $scope.checkMismatchWarning = function() {
                LocationService.getCountries(countries => {
                    $scope.thereIsMismatch = $scope.newSite.countryRaw && $scope.newSite.siteUsage &&
                        countries[$scope.newSite.countryRaw].zone !== $scope.newSite.siteUsage.region;
                });

                return false;
            }

            $scope.canUseSecondaryWan = function() {
                return !['VSOCKET_VGX_AZURE', 'VSOCKET_VGX_AWS'].includes($scope.newSite.siteConnType.value);
            }
        }]
    }
});
